import type { CSSObject } from '@emotion/react'
import { Badge } from '@mantine/core'
import { colors } from 'settings/colors'

export const CountBadge = ({ count, style }: { count: number; style?: CSSObject }) => {
  return (
    <Badge
      css={{
        alignItems: 'center',
        borderRadius: '50%',
        color: colors.white,
        display: 'flex',
        fontSize: 12,
        height: 20,
        justifyContent: 'center',
        minWidth: 20,
        backgroundColor: colors.grey500,
        padding: 2,
        marginLeft: 10,
        ...style,
      }}
      styles={{ root: { alignSelf: 'center' } }}
      radius="xl"
      size="sm"
    >
      {count}
    </Badge>
  )
}
